// src/i18n.js
import { createI18n } from 'vue-i18n';

const messages = {
    en: {
        message: {
            hello: 'Hello world',
            // Agrega aquí todas las traducciones en inglés
        },
        // Otros mensajes en inglés
    },
    es: {
        message: {
            hello: 'Hola mundo',
            // Agrega aquí todas las traducciones en español
        },
        // Otros mensajes en español
    },
};

const i18n = createI18n({
    locale: 'es', // Idioma por defecto
    messages,
});

export default i18n;
